import React from 'react';
import styles from './ModuleCSS/Support.module.css';
import { useTranslation } from 'react-i18next';

function Support() {
  const [t] = useTranslation();

  return (
    <div className={styles.container}>
      <h2>{t('how-can-we-help')}</h2>
      <p>{t('albus-support-available-open-hours')}</p>
      <div className={styles.wrapper}>
        <div className={styles.support}>
          <p className={styles.supportTxtHead}>{t('phone')}</p>
          <a href="tel:+46103037470">
            <p className={styles.supportTxtCont}>010-303 74 70</p>
          </a>
        </div>
        <div className={styles.support}>
          <p className={styles.supportTxtHead}>E-mail</p>
          <a href="mailto:info@albuscare.com">
            <p className={styles.supportTxtCont}>info@albuscare.com</p>
          </a>
        </div>
      </div>

      <div className={styles.returnB}>
        <h3>{t('return-of-device')}</h3>
        <p>{t('return-of-device-info-text-30-days')}</p>
        {/* <ul>
          <li>
            <span className={styles.highlight}>
              {t('lost-or-destoryed-device')}:{' '}
            </span>
            1 000 kr
          </li>
          <li>
            <span className={styles.highlight}>
              {t('lost-or-destroyed-cable')}:{' '}
            </span>
            150 kr
          </li>
          <li>
            <span className={styles.highlight}>
              {t('lost-or-destroyed-case')}:{' '}
            </span>
            50 kr
          </li>
        </ul> */}
        <ul>
          <li className={styles.highlight}>{t('return-address')}</li>
          <li>Albus Care System AB</li>
          <li>SVARSPOST</li>
          <li>20922727</li>
          <li>824 20 HUDIKSVALL</li>
        </ul>
      </div>

      <div className={styles.wrapperAction}>
        <a
          className={styles.link}
          href="https://www.albuscare.com/behandlare"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('manual-foer-behandlare')}
        </a>
        <a
          className={styles.link}
          href="https://www.albuscare.com/start"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('manual-foer-klient')}
        </a>
        <a
          className={styles.link}
          href="https://www.albuscare.com/datahantering-sekretess"
          rel="noreferrer"
          target="_blank"
        >
          {t('sekretess-and-integritetspolicy')}
        </a>
        <a
          className={styles.link}
          href="https://www.albuscare.com/allmanna-villkor"
          rel="noreferrer"
          target="_blank"
        >
          {t('allmaenna-villkor')}
        </a>
      </div>
    </div>
  );
}

export default Support;
